import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isProgramsOpen, setIsProgramsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { 
      label: 'Programs', 
      dropdown: true,
      items: [
        { path: '/track-1', label: 'Track 1: Personal Mastery' },
        { path: '/track-2', label: 'Track 2: Mastery Through Trade' }
      ]
    },
    { path: '/donate', label: 'Donate' },
    { path: '/events', label: 'Events' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-[87.5rem] mx-auto px-5 md:px-10">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_8209053d-0b10-4383-98c6-27ad656e5b2c/artifacts/8eb1dchd_image.png" 
              alt="MOS Veteran Logo" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link, idx) => (
              link.dropdown ? (
                <div 
                  key={idx} 
                  className="relative"
                  onMouseEnter={() => setIsProgramsOpen(true)}
                  onMouseLeave={() => setIsProgramsOpen(false)}
                >
                  <button
                    className="px-4 py-2 text-sm font-semibold uppercase transition-colors text-[#0A277A] hover:text-[#D80000] flex items-center"
                  >
                    {link.label}
                    <ChevronDown size={16} className="ml-1" />
                  </button>
                  {isProgramsOpen && (
                    <div className="absolute top-full left-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg min-w-[250px] py-2">
                      {link.items.map((item) => (
                        <Link
                          key={item.path}
                          to={item.path}
                          className="block px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-[#D80000] transition-colors"
                        >
                          {item.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2 text-sm font-semibold uppercase transition-colors ${
                    isActive(link.path)
                      ? 'text-[#D80000]'
                      : 'text-[#0A277A] hover:text-[#D80000]'
                  }`}
                >
                  {link.label}
                </Link>
              )
            ))}
            <Link to="/donate">
              <Button className="ml-4 bg-[#D80000] text-white hover:bg-[#b00000] rounded-full px-6 font-semibold uppercase shadow-md">
                Support Us
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-[#0A277A] p-2"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            {navLinks.map((link, idx) => (
              link.dropdown ? (
                <div key={idx}>
                  <div className="px-4 py-3 text-base font-semibold uppercase text-[#0A277A]">
                    {link.label}
                  </div>
                  {link.items.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      onClick={() => setIsOpen(false)}
                      className="block px-8 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#D80000]"
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={`block px-4 py-3 text-base font-semibold uppercase transition-colors ${
                    isActive(link.path)
                      ? 'text-[#D80000] bg-gray-50'
                      : 'text-[#0A277A] hover:text-[#D80000] hover:bg-gray-50'
                  }`}
                >
                  {link.label}
                </Link>
              )
            ))}
            <div className="px-4 pt-4">
              <Link to="/donate" onClick={() => setIsOpen(false)}>
                <Button className="w-full bg-[#D80000] text-white hover:bg-[#b00000] rounded-full py-6 font-semibold uppercase shadow-md">
                  Support Us
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;